import { ScrollableContent } from "@homebound/beam";
import { HistoryFeed } from "src/components";
import { useMaterialListingHistoryQuery } from "src/routes/libraries/material-catalog/components/MaterialListingFormHistoryTab.generated";
import { queryResult } from "src/utils";

export function MaterialListingFormHistoryTab({ materialListingId }: { materialListingId: string }) {
  const query = useMaterialListingHistoryQuery({ variables: { materialListingId } });
  return queryResult(query, {
    data: ({ materialListings }) => (
      <ScrollableContent>
        <HistoryFeed historyItems={materialListings.entities.first?.history ?? []} />
      </ScrollableContent>
    ),
  });
}
